export default __webpack_public_path__ + "static/media/search.99a4b9f0.svg";